<p>delete-cash-flow-fli works!</p>
